import { Box, Typography } from "@mui/material";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import type { FC } from "react";

export const LaunchAIContentCard: FC<{
  title: string;
  format: string;
  image: string;
  "data-analytics-id"?: string;
}> = ({ title, format, image, "data-analytics-id": analyticsId }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    const params = new URLSearchParams({ format });

    void navigate({ pathname: "/", search: params.toString() });
  }, [navigate, format]);

  return (
    <Box
      data-analytics-id={analyticsId}
      onClick={handleClick}
      sx={{
        maxWidth: "160px",
        background: "linear-gradient(to right bottom, #00B6EF, #C24599)",
        color: "white",
        borderRadius: "4px",
        cursor: "pointer",
        position: "relative",
      }}
    >
      <Box
        component="img"
        sx={{
          height: "65px",
          maxWidth: "160px",
          display: "block",
        }}
        alt={title}
        src={image}
      ></Box>
      <Box
        alignItems="center"
        justifyContent="center"
        display="flex"
        sx={{
          height: "35px",
          background: "linear-gradient(to right bottom, #00B6EF, #C24599)",
          width: "100%",
          maxWidth: "160px",
          borderRadius: "0 0 4px 4px",
        }}
      >
        <Typography variant="body2">{title}</Typography>
      </Box>
    </Box>
  );
};
